import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {
    IQueryContextChange,
    QueryContextSettingID,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    QueryContextChange,
    QueryContextService,
} from 'src/app/services/query-context/query-context.service';

// TODO flatten
export interface IToggleSettingDashboardItem {
    options: {
        id: QueryContextSettingID;
        viewtype: 'toggle';
        displayName?: string;
        description?: string;
        /** Current value */
        value?: any;
        /** Possible values */
        selectOptions?: any;
        /** Custom onChangeQueryContextCallback which will be called on toggle change */
        onChangeQueryContextCallback?: (
            value: any,
            option: IToggleSettingDashboardItem['options'],
            queryContextService: QueryContextService
        ) => void;
    };
}

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent implements OnInit {
    @Input()
    option!: IToggleSettingDashboardItem['options'];
    @Output()
    change = new EventEmitter<IQueryContextChange>();

    /** Current value */
    currentValue!: any;

    constructor(
        private queryContextService: QueryContextService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.currentValue = this.option.value;
        this.queryContextService.appliedQueryContextEmitter.subscribe(
            this.queryContextSubscriber
        );
    }

    onChange(value: any) {
        this.currentValue = value;
        console.log({
            msg: 'ToggleComponent.onChange',
            id: this.option.id,
            value: this.currentValue,
        });

        const notifyQueryContextService =
            this.option.onChangeQueryContextCallback ||
            ToggleComponent.onChangeQueryContextCallback;

        notifyQueryContextService(value, this.option, this.queryContextService);
    }

    static onChangeQueryContextCallback(
        value: any,
        option: IToggleSettingDashboardItem['options'],
        queryContextService: QueryContextService
    ) {
        console.log({
            msg: 'ToggleComponent.onChangeQueryContextCallback',
            id: option.id,
            value: value,
        });

        queryContextService.changePendingQueryContext({
            setting: { id: option.id, value: value },
        });
    }

    queryContextSubscriber = (contextChange: QueryContextChange) => {
        if (contextChange.reason === 'InitialContext') {
            // if option id in contextChange.context.settings
            // then set value from contextChange.context.settings
            const setting = contextChange.context.settings[this.option.id];
            if (setting) {
                this.currentValue = setting;
                this.cd.detectChanges();
            }
        }
    };
}
